export interface IConfig {
	logging: boolean,
	cookies: {
		name: string,
	},
	api: {
		baseUrl: string,
		timeout: number
	},
	language: string,
	tablePageSize: number,
	appearance?: any
}

export const AppConfigDev: IConfig = {
	logging: false,
	cookies: {
		name: 'amosevideus2',
	},
	api: {
		baseUrl: 'http://localhost:3010',
		timeout: 30000
	},
	language: 'rs',
	tablePageSize: 10,
	appearance: {
	}
}

export const AppConfigTest: IConfig = {
	logging: false,
	cookies: {
		name: 'amosevideus2',
	},
	api: {
		baseUrl: 'http://localhost:3010',
		timeout: 30000
	},
	language: 'rs',
	tablePageSize: 10,
	appearance: {
	}
}

export const AppConfigProd: IConfig = {
	logging: false,
	cookies: {
		name: 'amosevideus2'
	},
api: {
    baseUrl: '/api',
    timeout: 30000
},
	language: 'rs',
	tablePageSize: 10,
	appearance: {
		clientPageHideFinanceButton: true,
		hideFinances: false,
		hideContracts: false,
		hideReports: false,
		hideServices: false
	}
}



export const AppConfig = (): IConfig => {
	switch (process.env.NODE_ENV) {
		case 'development':
			return AppConfigDev
		case 'production':
			return AppConfigProd
		case 'test':
			return AppConfigTest
	}
}
